import {  Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvisibleRecaptchaService {
  constructor(private service: ReCaptchaV3Service) {}

  getCaptcha(action: string): Observable<string> {
    return this.service.execute(action);
  }
}